import { OnboardingClientService } from "../../../../services/onboarding/onboarding-client.service";
import { OnboardingSession } from "../onboarding.session";
import { computedFrom } from "aurelia-binding";
import { MobileHelper } from "../../../../helpers/mobile-helper";
import { Reflection } from "../../../../utilities/reflection";

export abstract class BaseOnboardingStepModel {

    protected _canShow: boolean = true;
    protected _canGoNext: boolean = true;
    protected _canGoBack: boolean = true;
    protected scrollElement: HTMLDivElement;

    public canCompleteSession: boolean = false;
    public isNext: boolean;

    constructor(protected onboardingClientService: OnboardingClientService,
        protected onboardingSession: OnboardingSession) { }

    activate(model: { isNext: boolean }) {
        this.isNext = model ? model.isNext : false;
        this.onActivated();
        this.canCompleteSession = this.onboardingSession.canCompleteSession();
        this.scrollToTop();
    }

    scrollToTop() {
        if (!this.scrollElement) {
            this.scrollElement = MobileHelper.getScrollParent(document.getElementsByClassName('compose-content').item(0), false) as HTMLDivElement;
        }

        setTimeout(() => {
            if (this.scrollElement) {
                this.scrollElement.scrollTop = 0;
            }
        });
    }

    onActivated() { }

    public prepare(): Promise<void> {
        return new Promise<void>((resolve) => {
            resolve();
        });
    }

    @computedFrom(Reflection.getPropertyPath<BaseOnboardingStepModel>(x => x._canGoBack))
    public get canGoBack() {
        return (this._canGoBack && this.onboardingSession.currentStepIndex > 0) || this.onboardingSession.isEmbedded;
    }

    @computedFrom(Reflection.getPropertyPath<BaseOnboardingStepModel>(x => x._canGoNext))
    public get canGoNext() {
        return this._canGoNext;
    }

    @computedFrom(Reflection.getPropertyPath<BaseOnboardingStepModel>(x => x._canShow))
    public get canShow(): boolean {
        return this._canShow;
    }

    public back() {
        if (this.canGoBack) {
            this.onboardingSession.prevStep();
        }
    }

    next(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.save().then(() => {
                this.onboardingSession.nextStep(this).then(resolve).catch(reject);
            }).catch(reject);
        });
    }

    save(): Promise<void> {
        return new Promise<void>((resolve) => {
            resolve();
        });
    }
}
